import { render, staticRenderFns } from "./WebList.vue?vue&type=template&id=225f3640&scoped=true&"
import script from "./WebList.vue?vue&type=script&lang=js&"
export * from "./WebList.vue?vue&type=script&lang=js&"
import style0 from "./WebList.vue?vue&type=style&index=0&id=225f3640&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "225f3640",
  null
  
)

export default component.exports